import type {
  InterventionDuplicateFormProps,
  InterventionDuplicateFormValues,
} from "./intervention-duplicate-form.type";
import type {
  InterventionEntity,
  InterventionDuplicateVariables,
} from "@/entities/intervention";

import { useModelDuplicateForm } from "@/modules/model-duplicate";

export const useInterventionDuplicateForm = ({
  intervention,
}: InterventionDuplicateFormProps) => {
  return useModelDuplicateForm<
    InterventionEntity,
    InterventionDuplicateFormValues,
    InterventionDuplicateVariables
  >({
    modelKey: "intervention",
    item: intervention,
    valuesToVariables: (values) => ({
      name: values.name,
      duplicate_content: values.duplicate_content ?? false,
    }),
    validationNames: ["name", "duplicate_content"],
  });
};
